import codes from '@/api/codes';
import { handleMenu } from '@/assets/js/handleMenu';

/**
 * 配置路由参数
 * @param menuData 当前被点击项的所有菜单结构
 * @param currentMenu 当前被点击的菜单项
 * @param clickTag 点击标记：菜单1；文章2
 */

export function configureParams(menuData, currentItem, clickTag) {
  // 1.点击菜单——返回其上下级所有菜单的id、菜单的类型、二级菜单的名称
  // 2.点击文章——一级、二级菜单id、文章类型、文章id
  // first 一级菜单ID
  // second 二级菜单ID
  // third 三级菜单ID
  // fourth 四级菜单ID
  // type 文章类型
  // name 二级菜单名称
  // detailID 文章ID
  // isDown
  // sort 第三层
  let query = null;

  let menuLevel = handleMenu(menuData);

  // 点击栏目菜单
  if (clickTag === codes.MENU) {
    if (menuLevel.length === 1) {
      query = {
        first: menuLevel[0].id,
        type: menuLevel[0].type,
        name: menuLevel[0].name,
        isDown: currentItem.isDown,
      };
    } else if (menuLevel.length === 2) {
      query = {
        first: menuLevel[0].id,
        second: menuLevel[1].id,
        type: menuLevel[1].type,
        name: menuLevel[1].name,
        isDown: currentItem.isDown,
      };
    } else if (menuLevel.length === 3) {
      query = {
        first: menuLevel[0].id,
        second: menuLevel[1].id,
        third: menuLevel[2].id,
        type: menuLevel[2].type,
        name: menuLevel[1].name,
        isDown: currentItem.isDown,
        sort: menuLevel[2].sort,
      };
    } else if (menuLevel.length === 4) {
      query = {
        first: menuLevel[0].id,
        second: menuLevel[1].id,
        third: menuLevel[2].id,
        fourth: menuLevel[3].id,
        type: menuLevel[3].type,
        name: menuLevel[1].name,
        isDown: currentItem.isDown,
        sort: menuLevel[2].sort,
      };
    }
  } else if (clickTag === codes.ARTICLE) {
    if (menuLevel.length === 1) {
      query = {
        first: menuLevel[0].id,
        type: currentItem.menuType,
        name: menuLevel[0].name,
        detailID: currentItem.id,
      };
    } else if (menuLevel.length === 2) {
      query = {
        first: menuLevel[0].id,
        second: menuLevel[1].id,
        type: currentItem.menuType,
        name: menuLevel[1].name,
        detailID: currentItem.id,
        isDown: menuLevel[1].isDown,
      };
    } else if (menuLevel.length === 3) {
      query = {
        first: menuLevel[0].id,
        second: menuLevel[1].id,
        // third: menuLevel[2].id,
        type: currentItem.menuType,
        name: menuLevel[1].name,
        detailID: currentItem.id,
        isDown: menuLevel[2].isDown,
        sort: menuLevel[2].sort,
      };
    } else if (menuLevel.length === 4) {
      query = {
        first: menuLevel[0].id,
        second: menuLevel[1].id,
        // third: menuLevel[2].id,
        // fourth: menuLevel[3].id,
        type: currentItem.menuType,
        name: menuLevel[1].name,
        detailID: currentItem.id,
        isDown: menuLevel[3].isDown,
        sort: menuLevel[2].sort,
      };
    }
  }
  return query;
}



// WEBPACK FOOTER //
// ./src/assets/js/configureParams.js